var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFAE55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7564 20.0683H36.1459C38.4421 20.0683 40.3066 21.9327 40.3066 24.229V24.7978C40.3066 28.5356 37.2717 31.5705 33.5339 31.5705H14.6692C10.7646 31.5705 7.5957 28.4016 7.5957 24.497V24.229C7.5957 21.9327 9.46013 20.0683 11.7564 20.0683Z",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8679 27.1477C14.7495 27.1477 15.4642 26.433 15.4642 25.5513C15.4642 24.6697 14.7495 23.955 13.8679 23.955C12.9862 23.955 12.2715 24.6697 12.2715 25.5513C12.2715 26.433 12.9862 27.1477 13.8679 27.1477Z",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0964 27.1477C34.978 27.1477 35.6928 26.433 35.6928 25.5513C35.6928 24.6697 34.978 23.955 34.0964 23.955C33.2147 23.955 32.5 24.6697 32.5 25.5513C32.5 26.433 33.2147 27.1477 34.0964 27.1477Z",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9844 26.153H29.981",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3704 12.5957H15.6084C14.8787 12.5957 14.2175 13.0216 13.9137 13.6857L11.0039 20.0683H36.9778L34.068 13.6857C33.7642 13.0216 33.103 12.5957 32.3733 12.5957H32.3704Z",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4358 16.9172H8.94519C8.07255 16.9172 7.43816 18.4212 8.39123 19.0556C9.34131 19.69 10.1157 20.1814 10.1157 20.1814",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6934 16.9172C35.6934 16.9172 38.3143 16.9172 39.1839 16.9172C40.0566 16.9172 40.691 18.4212 39.7379 19.0556C38.7878 19.69 38.0135 20.1814 38.0135 20.1814",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8058 31.5676V34.5042C13.8058 35.5555 12.954 36.4073 11.9027 36.4073H10.1961C9.14477 36.4073 8.29297 35.5555 8.29297 34.5042V28.5386",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2188 31.5676V34.5042C34.2188 35.5555 35.0705 36.4073 36.1219 36.4073H37.8285C38.8798 36.4073 39.7316 35.5555 39.7316 34.5042V28.5386",
    stroke: "white",
    strokeWidth: 1.19133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.8992,
    height: 25,
    fill: "white",
    transform: "translate(7 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.837f1fa75d236426d552576c53a15cbd.svg";
export { ForwardRef as ReactComponent };